import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    moduleId: module.id,
    selector: 'onoffswitch',
    templateUrl: 'onoffswitch.component.html',
    styleUrls: ['onoffswitch.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => OnoffswitchComponent),
        multi: true
    }]
})

export class OnoffswitchComponent {
    check: boolean = false;
    @Input()
    disabled:boolean=false;
    @Input()
    available:boolean=false;
    @Input()
    label:boolean=false;
    @Input()
    avatar
    _onChange = (_: any) => { };
    _onTouched = () => { };

    writeValue(value: any): void {
        this.check = value;
        this._onChange(value);
    }

    registerOnChange(fn: (_: any) => {}): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this._onTouched = fn;
    }

    /**
     * Utility method to get values from
     * selected items
     * @returns {boolean}
     */
    private getValues(): boolean {
        return this.check;
    }

    change(){
        this.writeValue(this.getValues());
    }
}
